import axios, { CreateAxiosDefaults } from "axios";
import { getSureApiUrl, handleProfiling } from "./utils";
import i18next from "i18next";

const adminConfig: CreateAxiosDefaults = {
    baseURL: getSureApiUrl(),
    withCredentials: true,
    headers: {
        common: {
            "Content-Type": "application/ld+json",
            Accept: "application/ld+json",
        },
    },
};

export const sureApiCall = axios.create({ ...adminConfig });

sureApiCall.interceptors.request.use((config) => {
    handleProfiling(config);

    const configuredLocale = config.headers.get("Accept-Language");
    const locale =
        typeof configuredLocale === "string" && configuredLocale.trim().length > 0 ?
            configuredLocale
        :   i18next.resolvedLanguage || "en";
    config.headers.set("Accept-Language", locale);

    return config;
});
